// extracted by mini-css-extract-plugin
export default {"tabs-list":"Je03h"};